import { Box } from '@chakra-ui/react';

export default function ShopifyLandingPage() {
  // Once Shopify will redirect to Kintsugi user will land in this page and will show the select org modal upon this page. this page have just a white background.
  return <Box></Box>;
}
